// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__zQrah","title":"Info_title__Y2-FB","links":"Info_links__1sT1a","link":"Info_link__1ALvw","logo":"Info_logo__3RC6X"};